import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --background: #f5f5f5;
    --color-primary: #004386;
    --color-secondary: #004386;
    --color-thirdy: #fce3d9;
    --linear-blue: linear-gradient(180deg, #004386 0%, #3EE7FA 99.48%);
    --background-content: #fffcf3;
    --background-item: #FFF7DF;
    --region-percentage: #004386;
    --percentage: #004386;
    --background-trilha: #004386;
    --linear-green: linear-gradient(180deg, #004386 0%, #15DFF5 99.48%);
    --text-title: #2da3c9;
    --text-body: #2a2a2a;
    --selected: #004386;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
  }

  html {
    @media(min-width: 1080px) {
      font-size: 93.75%;
    }
    @media(min-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    background: var(--background);
    -webkit-font-smoothing: antialiased;
  }

  button {
    cursor: pointer;
  }

  a, button {
    transition: filter 0.2s;
    &:hover {
      filter: brightness(0.9);
    }
  }
`;
